import React, { useState, useEffect } from 'react';
import './BlackberryHeroCaraousel.scss';

const images = [
    {
        id: 1,
        image: 'https://firebasestorage.googleapis.com/v0/b/elnora-prod.firebasestorage.app/o/banners%2Fekbplbjapdbtbnmcktwd.webp?alt=media&token=6db98c83-7402-43dd-8842-443fe077f7da'
    },
    {
        id: 2,
        image: 'https://firebasestorage.googleapis.com/v0/b/elnora-prod.firebasestorage.app/o/banners%2Fpgg6rklducckbwu53nhs.webp?alt=media&token=bb2cee0d-97d7-4929-9481-2d2da1f8ce91'
    },
    {
        id: 3,
        image: 'https://firebasestorage.googleapis.com/v0/b/elnora-prod.firebasestorage.app/o/banners%2Fu62z48d5dl1bxccqe29m.webp?alt=media&token=4f97c3bb-3f4a-45dc-bb93-c4cdfcda4ab2'
    },
    {
        id:4,
        image:"https://firebasestorage.googleapis.com/v0/b/elnora-prod.firebasestorage.app/o/banners%2Fveah62okyoeymysou5ho.webp?alt=media&token=b89de2e9-ab66-41a7-9aed-7229880fa237"
    }
];

const BlackberryHeroCaraousel = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentSlide((prevSlide) => 
                prevSlide === images.length - 1 ? 0 : prevSlide + 1
            );
        }, 5000);

        return () => clearInterval(timer);
    }, []);

    const handleDotClick = (index) => {
        setCurrentSlide(index);
    };

    return (
        <div className='bb-hero-carousel'>
            <div className='carousel-container'>
                {images.map((slide, index) => (
                    <div 
                        key={slide.id}
                        className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}
                    >
                        <img src={slide.image} alt={`Slide ${slide.id}`} />
                        {/* <div className='slide-content'>
                            <h2>Fashion Collection {slide.id}</h2>
                            <p>Discover the latest trends in fashion</p>
                            <button className='shop-now-btn'>Shop Now</button>
                        </div> */}
                    </div>
                ))}
            </div>
            
            <div className='carousel-dots'>
                {images.map((_, index) => (
                    <button
                        key={index}
                        className={`dot ${index === currentSlide ? 'active' : ''}`}
                        onClick={() => handleDotClick(index)}
                        aria-label={`Go to slide ${index + 1}`}
                    />
                ))}
            </div>
        </div>
    );
};

export default BlackberryHeroCaraousel;